import React, { Component } from 'react';
import Connector from '../../data/Connector';
import { withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class StaffInactivePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
    }
  }


  componentDidMount() {
    Connector.setUser()
    document.title = 'Business Portal - PT Mate'
    window.scrollTo(0, 0)
  }


  logoutUser() {
    HelperPage.signOut()
  }



  // Display stuff ------------------------------------------------------------



  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content member-select">
              <div className="member-confirm unauth">
                <h2>{lang.t('auth:access.title')}</h2>
                <p>{lang.t('auth:access.text')}</p>
              </div>
              <div className="space-40"></div>
              <button className="btn primary" onClick={() => this.logoutUser()}>{lang.t('common:button.close')}</button>
            </div>
          </div>
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['auth','common'])(withRouter(withAuthorization(condition)(StaffInactivePage)));